import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthViewModel } from '../ViewModel/AuthViewModel';

const PublicLayout: React.FC = () => {

  const { checkAuthentication } = useAuthViewModel();
  const isAuthenticated = checkAuthentication();

  if (isAuthenticated) {
    return <Navigate to="/sites" replace />;
  }
  
  return (
    <div className="flex flex-col min-h-screen bg-public-background">
      <Outlet />
    </div>
  );
};

export default PublicLayout;